<template>
  <div class="contact">
    <div class="banner">
      <div class="banner-inner">
        <h1 class="banner-title aw-anim">携手共建 农业新生态</h1>
        <p class="banner-desc aw-anim">
          以数据智能构建农业产业生态，服务多类产业角色，打通生产交易闭环，期待与您共启农业数智新篇
        </p>
        <button class="banner-btn aw-anim" @click="onConsult">
          我要留言
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>

    <!-- ============ 联系我们 ============ -->
    <section class="contact-section">
      <h2 class="section-title aw-anim">联系我们</h2>
      <div class="contact-cards">
        <div class="contact-card aw-anim">
          <div class="card-icon">
            <img src="@/assets/concat/icon1.png" alt="" />
          </div>
          <div class="card-info">
            <h3 class="card-title">电话联系</h3>
            <p class="card-sub">24小时咨询电话</p>
            <p class="card-value">
              <img src="@/assets/concat/icon3.png" alt="" />
              400-8660808
            </p>
          </div>
        </div>
        <div class="contact-card aw-anim">
          <div class="card-icon">
            <img src="@/assets/concat/icon2.png" alt="" />
          </div>
          <div class="card-info aw-anim">
            <h3 class="card-title">邮箱联系</h3>
            <p class="card-sub">官方邮箱地址</p>
            <p class="card-value">
              <img src="@/assets/concat/icon4.png" alt="" />
              yjszkj2025@163.com
            </p>
          </div>
        </div>
      </div>
      <!-- 腾讯地图容器（key 已在 public/index.html 引入） -->
      <div class="map-wrap aw-anim" ref="mapContainer"></div>
    </section>

    <!-- ============ 在线留言 ============ -->
    <ContactMessageForm />
  </div>
</template>

<script>
import ContactMessageForm from "@/components/ContactMessageForm.vue";

export default {
  name: "Contact",
  components: { ContactMessageForm },
  data() {
    return {
      // 公司地址：武汉市洪山区光谷时代广场B座（如需调整改这里即可，lat 在前 lng 在后）
      companyPos: { lat: 30.33643, lng: 114.38737 },
      map: null,
      mapRetryTimer: null,
    };
  },
  mounted() {
    this.initMap();
  },
  beforeDestroy() {
    if (this.mapRetryTimer) {
      clearTimeout(this.mapRetryTimer);
      this.mapRetryTimer = null;
    }
    if (this.map) {
      this.map.destroy();
      this.map = null;
    }
  },
  methods: {
    onConsult() {
      const el = document.getElementById("message-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.location.hash = "#message-section";
      }
    },
    // 初始化腾讯地图（TMap 由 index.html 的 script 标签全局引入）
    initMap() {
      if (!window.TMap) {
        // script 未加载完成（网络慢时），0.5s 后重试
        this.mapRetryTimer = setTimeout(this.initMap, 500);
        return;
      }
      try {
        const center = new window.TMap.LatLng(
          this.companyPos.lat,
          this.companyPos.lng,
        );
        this.map = new window.TMap.Map(this.$refs.mapContainer, {
          center,
          zoom: 13,
          viewMode: "2D",
        });
        // mark 标记：蓝色气泡图标（尖端对准公司坐标）
        new window.TMap.MultiMarker({
          map: this.map,
          styles: {
            marker: new window.TMap.MarkerStyle({
              src: require("@/assets/concat/markicon.png"),
              // 原图 192x92（@2x），按一半尺寸显示保证清晰度
              width: 120,
              height: 46,
              // 锚点 = 气泡尖端（底部中心），对准坐标点
              anchor: { x: 48, y: 46 },
            }),
          },
          geometries: [{ id: "company", styleId: "marker", position: center }],
        });
      } catch (e) {
        // console.warn("腾讯地图初始化失败：", e);
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.contact {
  width: 100%;
  background: #ffffff;
}

/* ============ 顶部 banner ============ */
.banner {
  width: 100%;
  height: 564px;
  background-image: url("../../assets/concat/banner.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.banner-inner {
  width: 1196px;
  margin: 0 auto;
  padding-top: 150px;
  font-size: 0;
}

.banner-title {
  font-size: 44px;
  font-weight: 700;
  color: #2e6be6;
  margin: 0 0 12px;
}

.banner-desc {
  width: 610px;
  font-size: 18px;
  line-height: 31px;
  color: #333333;
  margin: 0 0 80px;
}

.banner-btn {
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 0 28px;
  background: #3982f7;
  color: #ffffff;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #2e6be6;
  }

  .btn-arrow {
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
}

/* ============ 公共标题 ============ */
.section-title {
  font-size: 32px;
  font-weight: 600;
  color: #1f232b;
  text-align: center;
  margin: 0 0 48px;
}

/* ============ 联系我们 ============ */
.contact-section {
  padding: 80px 0;
  background: #ffffff;
}

.contact-cards {
  width: 1196px;
  margin: 0 auto 80px;
  display: flex;
  gap: 20px;
}

.contact-card {
  flex: 1;
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 0px 20px 0px #0000001a;
  height: 208px;
  padding: 0 40px;
}

.card-icon {
  // flex: 0 0 88px;
  width: 86px;
  height: 86px;
  border-radius: 50%;
  // background: linear-gradient(135deg, #5c9aff 0%, #3982f7 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 40px;

  img {
    width: 100%;
    height: 100%;
  }
}

.card-title {
  font-size: 24px;
  font-weight: 500;
  color: #333;
  margin: 0 0 8px;
}

.card-sub {
  font-size: 16px;
  color: #666;
  margin: 0 0 20px;
}

.card-value {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 500;
  color: #3982f7;
  margin: 0;

  img {
    width: 32px;
    height: 32px;
    margin-right: 2px;
  }
}

.map-wrap {
  width: 1196px;
  height: 400px;
  margin: 0 auto;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(31, 35, 43, 0.05);
}

</style>
